const isElementVisible = (pathname: string, url: string) => pathname !== url;

export default isElementVisible;
